import Async from '~/Async';

import Log from '~/_Utility/Log';

class TEC {

    /**
     * @since 2.59.0
     * @method constructor
     */
    constructor() {
        // Declare and initialize
        this.async  = new Async();
        this.events = {
            attendeeModalOpen: 'show.bs.modal'
        };

        // Run initialization
        this.init()
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 2.59.0
     * @return void
     */
    init() {
        // Probably listen for the masonry thing here
        new Log('TEC initialized.', 'init');

        // Update the card icon when the cart is updated
        $('#attendee-fields').on(
            this.events.attendeeModalOpen,
            (e) => this.updateAttendeeModal(e)
        );

        // Remove the PDF ticket downloads when RSVP is set to "Not Going"
        this.hideNotGoingRsvps();
    }

    /**
     * Hides the ticket links for "Not Going" RSVPS.
     *
     * @since 2.80.0
     * @method hideNotGoingRsvps
     * @return void
     */
    hideNotGoingRsvps() {

        // Declare and initialize
        let selector  = '.tec__tickets-my-tickets-rsvp-attendee-list-wrapper';
        let container = $(selector);

        // If we are in the wrong place, bail
        if (!container.length)
            return;

        // Go through once and clear them
        container.find('.tribe-answer-select').each(function () {

            // Declare and initialize
            let val      = $(this).val();
            let item     = $(this).closest('.tribe-item');
            let notGoing = 'no' === val;

            // Set an identifier class
            item.addClass((notGoing ? 'not-' : 'is-') + 'going');

            // We only need to toggle on the passes for "Going" RSVPs
            if (notGoing)
                return;

            // Find it
            let pass = item.find('.tec-tickets__wallet-plus-passes-container');

            // Whoops
            if (!pass.length)
                return;

            // Show it them
            pass.css({display: 'flex'});

        });

    }

    /**
     * Refresh the contents of the cart dynamically.
     *
     * @since 2.59.0
     * @method updateAttendeeModal
     * @return void
     */
    updateAttendeeModal(e) {
        // Declare and initialize
        let contentSelector = '.modal-content';
        let content         = $(e.currentTarget).find(contentSelector);

        // Start loading
        content.addClass('loading');

        // Run the async post
        this.async.post('tec-attendee-modal', {
            routine: 'tec-attendee-modal',
            params:  {
                postId: $(e.currentTarget).data('eventId'),
            },
            success: {
                callback: (r) => {
                    // Stop loading
                    content.removeClass('loading');

                    // Get the new content
                    let newContent = $(r.data).find(contentSelector);

                    // Replace the content
                    content.html(newContent);
                }
            },
            fail:    {
                callback: (data) => {
                    // Stop loading
                    content.removeClass('loading');

                    // Let the user konw
                    alert('Unable to refresh attendee list. Please try again later.');
                }
            },
        });
    }

}

export default TEC;